import config from '@/components/alert/config/Config';
import message from '@/components/alert/message/Message';

export const alert = [
    {path: '/alert/messages', name: 'alert', component: message},
    {path: '/alert/config', name: 'alertConfig', component: config},
]